export const fetchGroupBarChartData = async (request, payload) => {
  try {
    const response = await request(
      "POST",
      `/v1/survey/charts`,
      {
        data: {
          location: payload.location,
          query: payload.query,
          group: payload.group,
          year: payload.year
        },
      },
      "survey_service"
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};


export function smartSort(data) {
  // Helper function to detect if a string contains a numeric range
  function isRange(str) {
    return /\d+\s*-\s*\d+/.test(str);
  }

  // Helper function to extract the first number from a range string
  function extractFirstNumber(str) {
    const match = str.match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  // Helper function to get sorting priority and value for a field
  function getFieldSortInfo(field) {
    if (isRange(field)) {
      return {
        priority: 0, // Range has highest priority
        value: extractFirstNumber(field) // Numeric value for comparison
      };
    }
    return {
      priority: 1, // Non-range has lower priority
      value: field // String value for lexical comparison
    };
  }

  return [...data].sort((a, b) => {
    // Get sorting info for all fields
    const aParentInfo = getFieldSortInfo(a.parent);
    const aChildInfo = getFieldSortInfo(a.child);
    const bParentInfo = getFieldSortInfo(b.parent);
    const bChildInfo = getFieldSortInfo(b.child);

    // Find the highest priority field for each item
    const aHighestPriority = Math.min(aParentInfo.priority, aChildInfo.priority);
    const bHighestPriority = Math.min(bParentInfo.priority, bChildInfo.priority);

    // If one item has range and other doesn't, prioritize the one with range
    if (aHighestPriority !== bHighestPriority) {
      return aHighestPriority - bHighestPriority;
    }

    // Both have same priority level, now compare systematically

    // First compare parents
    if (aParentInfo.priority !== bParentInfo.priority) {
      return aParentInfo.priority - bParentInfo.priority;
    }

    // Parents have same priority, compare parent values
    if (aParentInfo.priority === 0) {
      // Both parents are ranges, compare numerically
      const parentComparison = aParentInfo.value - bParentInfo.value;
      if (parentComparison !== 0) return parentComparison;
    } else {
      // Both parents are non-ranges, compare lexically
      const parentComparison = aParentInfo.value.localeCompare(bParentInfo.value);
      if (parentComparison !== 0) return parentComparison;
    }

    // Parents are equal, now compare children
    if (aChildInfo.priority !== bChildInfo.priority) {
      return aChildInfo.priority - bChildInfo.priority;
    }

    // Children have same priority, compare child values
    if (aChildInfo.priority === 0) {
      // Both children are ranges, compare numerically
      return aChildInfo.value - bChildInfo.value;
    } else {
      // Both children are non-ranges, compare lexically
      return aChildInfo.value.localeCompare(bChildInfo.value);
    }
  });
}

